// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__q2zTF","additionalInfo":"AgreementModal_additionalInfo__3U3Uy"};